import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { useNavigate } from 'react-router-dom'

const DataPwTimeOut = () => {

	const App = useApp()
	const navigate = useNavigate()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={() => navigate('/home/dataList')} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding center-cont">
				<i className="icon icon_password_time" />
				<h3 className="intro-tit mt_30">열람 시간이 초과되었습니다.</h3>
				<p className="intro-sub-tit mt_10">설정 시간이 초과되어 증명서 열람이 불가해요.<br />증명서를 다시 요청해보세요.</p>
			</div>
		</div>
	)
}

export default DataPwTimeOut
